import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import axios from 'axios';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { Col, Container, Row } from 'react-bootstrap';

import Login from '../NewHome/components/Login';
import OtpModal from '../NewHome/components/OtpModal';
// import { TopBar } from '../MoveToImprove/sections';
import SignUp from '../NewHome/components/SignUp';
import SuccessModal from '../NewHome/components/SuccessModal';
import WaitList from '../NewHome/components/WaitList';
import FAQSection from './FAQSection';
import MeetDocJen from '../Challenge/components/MeetDocJen';
import Modal from '../NewHome/components/Modal';
import Testimonial from './Testimonials';
import JenHealthChallenge from '../FullBodyLowImpact/JenHealthChallenge';
import Benefits from './Benefits';
import Features from './Features';
import Header from './Header';
import JoinPlan from './JoinPlan';
import DetailedProblem from './DetailedProblem';
import VideoSection from './VideoSection';
import LazyImage from '../../ui-core/Image';
import SeoTags from '../../components/SeoComponent';
import ErrorModal from '../../components/ErrorModal';

import {
  LOCAL_STORAGE_CONSTANT,
  BARE_FOOT_MINI_COURSE_FAQS,
  MODAL_TYPE,
  TEXT_CONSTANT,
  VIDEO_CONSTANT,
} from '../../constants/app';
import { removeItem } from '../../utils/cache';
import { SEGMENT_EVENTS, trackEvent } from '../../utils/Segment';
import { Wrapper } from '../NewHome';
import { getDisplayType, logOutput, scrollToTop } from '../../utils/helpers';
import useWindowWidth from '../../hooks/useWindowWidth';
import {
  getCanonicalLink,
  // bareFootSnippet,
  SeoTexts,
} from '../../services/SEO';
import { extractJSON } from '../../services/jsonUtil';
import { useCourseDetail } from '../../hooks/useCourseDetail';
import { withFooter } from '../../hoc/withFooter';
import { APP_ROUTES } from '../../route';

import '../Challenge/components/Next30Days/style.css';
import './style.css';

const BareFootMiniCourse = ({ history, match }) => {
  const [modalState, setModalState] = useState(null);
  const [countryCode, setCountryCode] = useState('us');
  const displayType = getDisplayType(useWindowWidth());
  const isMobileScreen = displayType === 'mobile';
  const endDate = dayjs('2024-06-02T23:59:59');
  const {
    challengeError,
    handleCourseRedirection,
    isLoading,
    setChallengeError,
    courseDetail,
  } = useCourseDetail(history, match);

  useEffect(() => {
    scrollToTop();
  }, []);

  const handleModalState = modalData => setModalState(modalData);

  const handleModalEvent = modalType => setModalState(modalType);

  useEffect(() => {
    axios
      .get('https://ipapi.co/json/')
      .then(response => {
        const data = response.data;
        setCountryCode(data.country_code.toLowerCase());
      })
      .catch(error => {
        logOutput(error);
      });
  }, []);

  const dialogClassName = (() => {
    switch (modalState) {
      case MODAL_TYPE.SUCCESS:
        return 'success-modal';
      case MODAL_TYPE.WAITLIST:
        return 'survey-modal';
      default:
        return undefined;
    }
  })();

  const handleClose = () => {
    removeItem(LOCAL_STORAGE_CONSTANT.SURVEY_SESSION);
    removeItem(LOCAL_STORAGE_CONSTANT.SURVEY_STATUS);
    setModalState(false);
  };

  const handleAuthFlow = (buttonTitle, eventType, section) => {
    trackEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
      button_title: buttonTitle,
      page: 'Bare-Foot Mini Course',
      section_title: `${section}`,
    });
    const user = extractJSON(LOCAL_STORAGE_CONSTANT.USER);
    if (user) {
      handleCourseRedirection();
    } else {
      trackEvent(SEGMENT_EVENTS.AUTH_FLOW_INITIATED, {
        page: 'Bare-Foot Mini Course',
        section_title: `${section}`,
      });
      handleModalEvent(eventType);
      if (isMobileScreen) {
        scrollToTop();
      }
    }
  };

  const renderModalContent = () => {
    switch (modalState) {
      case MODAL_TYPE.LOGIN:
        return (
          <Wrapper type={modalState} handleGoBack={() => setModalState(null)}>
            <Login
              page="Bare-Foot Mini Course"
              countryCode={countryCode}
              handleModalState={handleModalState}
              handleModalEvent={handleModalEvent}
              plan_id={courseDetail?.id}
            />
          </Wrapper>
        );
      case MODAL_TYPE.OTP:
        return (
          <Wrapper type={modalState} handleGoBack={() => setModalState(null)}>
            <OtpModal
              page="Bare-Foot Mini Course"
              handleModalState={handleModalState}
              handleModalEvent={handleModalEvent}
              plan_id={courseDetail?.id}
            />
          </Wrapper>
        );
      case MODAL_TYPE.SIGNUP:
        return (
          <Wrapper type={modalState} handleGoBack={() => setModalState(null)}>
            <SignUp
              page="Bare-Foot Mini Course"
              countryCode={countryCode}
              handleModalState={handleModalState}
              handleModalEvent={handleModalEvent}
              plan_id={courseDetail?.id}
            />
          </Wrapper>
        );
      case MODAL_TYPE.SUCCESS:
        return <SuccessModal />;
      case MODAL_TYPE.WAITLIST:
        return <WaitList />;
      default:
        return null;
    }
  };
  // const renderTopBar = () => {
  //   const currentDate = dayjs();
  //   // const earlyBidEndDate = dayjs('2024-02-22T23:59:59');
  //   // const extendedEarlyBidEndDate = dayjs('2024-02-25T23:59:59');
  //   // const finalEndDate = dayjs('2024-06-02T23:59:59');

  //   // currentDate > extendedEarlyBidEndDate
  //   //   ? finalEndDate
  //   //   : currentDate > earlyBidEndDate
  //   //   ? extendedEarlyBidEndDate
  //   //   : earlyBidEndDate;

  //   const text = 'Join now for a big discount!';

  //   // if (currentDate < earlyBidEndDate) {
  //   //   text = 'Early Bird Sale Ends Friday, 23rd Feb';
  //   // }
  //   //  else if (
  //   //   currentDate >= extendedEarlyBidEndDate &&
  //   //   currentDate <= finalEndDate
  //   // ) {
  //   //   text = 'Early Bird Sale Extended Ends Monday, 26th Feb';
  //   // }
  //   // else if (
  //   //   currentDate >= earlyBidEndDate &&
  //   //   currentDate <= extendedEarlyBidEndDate
  //   // ) {
  //   //   text = 'Early Bird Sale Extended Ends Monday, 26th Feb';
  //   // } else {
  //   //   text = 'Come join the course now!';
  //   // }
  //   const description =
  //     currentDate > endDate
  //       ? 'Signup & Join the challenge'
  //       : 'Join the challenge starting June 3rd 2024';

  //   return (
  //     <TopBar
  //       description={description}
  //       endDate={endDate.toString()}
  //       loading={isLoading}
  //       onClick={handleAuthFlow}
  //       text={text}
  //     />
  //   );
  // };

  const renderPageContent = () => (
    <div>
      {/* {renderTopBar()} */}
      <Header disabled={isLoading} onClick={handleAuthFlow} />
      <JoinPlan
        isLoading={isLoading}
        courseDetail={courseDetail}
        onClick={handleAuthFlow}
      />
      <VideoSection
        onClick={handleAuthFlow}
        btnText={TEXT_CONSTANT.SIGN_UP_HERE}
        title={TEXT_CONSTANT.ABOUT_BAREFOOT_MINI_COURSE}
        video={{
          mp4: VIDEO_CONSTANT.fullBodyLowImpactMp4,
          webm: VIDEO_CONSTANT.fullBodyBannerWebm,
        }}
      />
      <Testimonial />
      <Features onClick={handleAuthFlow} />
      <DetailedProblem onClick={handleAuthFlow} />
      <Benefits onClick={handleAuthFlow} />
      <JenHealthChallenge
        loading={isLoading}
        courseDetail={courseDetail}
        bareFoot={true}
        endDate={endDate}
        onClick={handleAuthFlow}
        text={TEXT_CONSTANT.JOIN_BAREFOOT_COURSE}
      />
      <FAQSection
        onClick={handleAuthFlow}
        faqs={BARE_FOOT_MINI_COURSE_FAQS}
        formatter={FAQFormatter}
      />
      <MeetDocJen lowBodyImpact={true} backColor="#CAD9E0" />
    </div>
  );

  const renderContentMobile = () => {
    if (modalState) {
      return renderModalContent();
    } else {
      return renderPageContent();
    }
  };

  return (
    <div className={clsx('main', isMobileScreen && modalState && 'h-100')}>
      {isMobileScreen &&
      ![MODAL_TYPE.SUCCESS, MODAL_TYPE.WAITLIST].includes(modalState)
        ? renderContentMobile()
        : renderPageContent()}
      {!isMobileScreen && (
        <Modal
          dialogClassName={dialogClassName}
          show={Boolean(modalState)}
          handleClose={handleClose}
        >
          {renderModalContent()}
        </Modal>
      )}
      <ErrorModal
        handleClose={() => setChallengeError(false)}
        handleCourseRedirection={handleCourseRedirection}
        isLoading={isLoading}
        page="Bare-Foot Mini Course"
        show={challengeError}
      />
      <SeoTags
        title={SeoTexts.BARE_FOOT_MINI_COURSE_TITLE}
        metaDescription={SeoTexts.BARE_FOOT_MINI_COURSE_DESCRIPTION}
        canonicalLink={getCanonicalLink(APP_ROUTES.BARE_FOOT_MINI_COURSE)}
        ogImgUrl={SeoTexts.BARE_FOOT_MINI_COURSE_OG_IMAGE_URL}
        twitterImgUrl={SeoTexts.BARE_FOOT_MINI_COURSE_TWITTER_IMAGE_URL}
        // richSnippet={bareFootSnippet}
      />
    </div>
  );
};

export const FAQFormatter = ({ section }) => {
  const {
    description,
    header,
    image,
    listItems,
    placeholderImage,
    reverseOrder,
    type,
    webpImage,
  } = section;
  const isMobileScreen = getDisplayType(useWindowWidth()) === 'mobile';
  const isIpadScreen = getDisplayType(useWindowWidth()) === 'ipad';
  const isDesktopScreen = getDisplayType(useWindowWidth()) === 'desktop';

  const renderField = () => {
    switch (type) {
      case 'ul':
        return (
          <React.Fragment>
            <ul className="text-start">
              {listItems.map((item, index) => (
                <span key={`faq-point-${index + 1}`}>
                  <li className="mb-2">{parse(item)}</li>
                </span>
              ))}
            </ul>
            {description && <div>{parse(description)}</div>}
          </React.Fragment>
        );

      default:
        return <div>{parse(description)}</div>;
    }
  };

  return (
    <Container>
      <Row
        className={clsx(
          'd-flex',
          reverseOrder && 'flex-row-reverse',
          (isMobileScreen || isIpadScreen) && 'flex-column',
        )}
      >
        <Col
          xs={12}
          md={isDesktopScreen ? 6 : 12}
          className="d-flex position-relative align-self-start"
        >
          <LazyImage
            className={clsx(
              'my-auto barefoot-section-image w-100',
              reverseOrder && !(isMobileScreen || isIpadScreen) && 'ms-auto',
            )}
            errorSrc={image}
            placeholderSrc={placeholderImage}
            src={webpImage}
          />
        </Col>
        <Col xs={12} md={isDesktopScreen ? 6 : 12} className="d-flex">
          <div className="faq-block">
            {header && <div className="mb-3">{parse(header)}</div>}
            {renderField()}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

FAQFormatter.propTypes = {
  section: PropTypes.object.isRequired,
};

BareFootMiniCourse.propTypes = {
  history: PropTypes.object,
  match: PropTypes.object,
};

export default withFooter(BareFootMiniCourse);
